import { useIsMobile } from 'shared/hooks';

import NavigationDesktop from './NavigationDesktop';
import NavigationMobile from './NavigationMobile';

export default function Navigation() {
    const isMobile = useIsMobile();

    return isMobile
        ? <NavigationMobile />
        : <NavigationDesktop />;
}
